export default __webpack_public_path__ + "static/banner-ppc-2-618237fb0d3ecb9f51e36ceceb00db49.png";